"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');
var _store = require('shared/store');
var _requests = require('shared/selectors/requests');



const getOpenRequestsActions = _utils.createAsyncActions('GetOpenRequests')
const markRequestHandledActions = _utils.createAsyncActions('MarkRequestHandled')

 const actionCreators = {
  getOpenRequestsActions,
  markRequestHandledActions,
}; exports.actionCreators = actionCreators

// Only the latest load's answer is stored, so a slow older one can't bring
// back a request handled since.
let lastLoad = 0

/* Reloads the caller's open requests. Sends nothing, and resolves to null,
 * when none of the caller's active orgs has KEYWORDS. A failure keeps the
 * list it had. */
const loadOpenRequests = () => {
  if (!_requests.selectHasKeywordsOrg.call(void 0, _store.getState.call(void 0, ))) return Promise.resolve(null)
  const load = ++lastLoad
  return _helpers.wsCommand(
    'GetOpenRequests', getOpenRequestsActions, {}, null, () => load === lastLoad,
  ).catch(() => null)
}

/* Marks a request handled. On success the request leaves the list at once;
 * the server's todos notification then reloads it for everyone. Rejects on
 * failure, and the request stays. */
const markRequestHandled = (TodoKey) =>
  _helpers.wsCommand('MarkRequestHandled', markRequestHandledActions, { TodoKey }, { TodoKey })

exports. default = {
  loadOpenRequests,
  markRequestHandled,
}
